<template>
  <v-card class="mt-3 rounded-card">
    <v-tabs v-model="tab" >
      <v-tab>Negociações</v-tab>
      <v-tab>Histórico de alterações</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <px-resposta-negociacao :resposta="resposta" />
      </v-tab-item>
      <v-tab-item>
        <px-resposta-detalhes-historico :resposta="resposta" />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import RespostaNegociacao from '../negociacao/RespostaNegociacao.vue';
import RespostaDetalhesHistorico from './RespostaDetalhesHistorico.vue';

export default {
  props: {
    resposta: Object,
  },
  data() {
    return {
      tab: 0,
    };
  },
  components: {
    pxRespostaNegociacao: RespostaNegociacao,
    pxRespostaDetalhesHistorico: RespostaDetalhesHistorico,
  },
};
</script>
